import classNames from "classnames";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { REACT_POPUP_OPEN } from "actions/station.action";
import { isMobile, isIOS, osVersion } from "react-device-detect";
import { TITLE } from "constant/board";
import i18next from "i18next";

const SelectBox = ({ options, value, onChange, align, className, stopPropagation }) => {
	const id = useCallback(Math.random(), []);
	const dispatch = useDispatch();
	const [active, setActive] = useState(false);
	const [selectValue, setSelectValue] = useState(value);
	const { reactPopupId } = useSelector((state) => state.stationReducer, shallowEqual);

	/**
	 * value 로  Option 가져오기
	 * @param {*} value
	 */
	const getOptionByValue = useCallback(
		(value) => {
			if (!options || options.length === 0 || Array.isArray(options) === false) {
				return "";
			}
			if (value=="catchstory"){
				return { value: "catch", name: i18next.t("Catch") };
			}
			return (
				options.find((option) => {
					return option.value == value;
				}) || options[0]
			);
		},
		[options],
	);

	useEffect(() => {
		setSelectValue(value);
	}, [value]);

	/**
	 * 다른팝업을 띄울경우
	 */
	useEffect(() => {
		if (id !== reactPopupId) {
			setActive(false);
		}
	}, [id, reactPopupId]);

	const handleClick = useCallback(
		(e) => {
			e.stopPropagation();
			e.nativeEvent.stopImmediatePropagation();
			setActive(!active);

			//창이 안닫히게 처리
			if (stopPropagation !== true) {
				dispatch({
					type: REACT_POPUP_OPEN,
					id,
				});
			}
		},
		[active, dispatch, id, stopPropagation],
	);

	const handleOptionClick = useCallback(
		(value) => () => {
			if (value !== selectValue) {
				setSelectValue(value);
				if (onChange) {
					onChange(value);
				}
			}
			setActive(false);
		},
		[onChange, selectValue],
	);

	const handleChange = useCallback(
		(e) => {
			const value = e.target[e.target.selectedIndex].value;
			if (value !== selectValue) {
				setSelectValue(value);
				if (onChange) {
					onChange(value);
				}
			}
			setActive(false);
		},
		[onChange, selectValue],
	);

	const { name, optional } = getOptionByValue(selectValue);
	const selectName = useMemo(() => optional && <em>{optional}</em>, [optional]);

	if (isMobile) {
		//ios 버전 16 사파리 이슈로 인해, ios 버전 16은 optgroup(제목) 비노출
		//ios 버전 16 모바일 사파리에서 코드 확인 결과 optgroup 태그가 닫히질 않음
		const IosOptgroupFlag = osVersion >= '16.0' && isIOS ? false : true;
		return (
			<div className={className}>
				<label htmlFor={`select_${id}`}>{name}</label>
				<select id={`select_${id}`} onChange={handleChange} value={selectValue === "catchstory" ? "catch" : selectValue}>
					{Array.isArray(options) &&
						options.map((option, index) => (
							//TITLE == display_type 107(제목) 이고, ios버전이 16이상 아닐 때만 optgroup(제목) 노출
							((option.display_type === TITLE) && IosOptgroupFlag) ?
							<optgroup key={index} value={option.value} label={`-- ${option.name} --`}></optgroup> : 
							////TITLE == display_type 107 아니면 그룹이니 option으로 표시 
							(option.display_type !== TITLE) && 
							<option key={index} value={option.value}> {option.name}{" "} </option>
						))}
				</select>
			</div>
		);
	} else {
		return (
			<div className={classNames("select-box", { active: active })}>
				<button type="button" className="selected" onClick={handleClick}>
					<span>{name}</span>
					{selectName}
				</button>
				<ul className="select-layer" data-align={align}>
					{Array.isArray(options) &&
						options.map((option, index) => (
							<li key={index}>
								<button type="button" onClick={handleOptionClick(option.value)}>
									<span>{option.name} </span>
									<em>{option.optional}</em>
								</button>
							</li>
						))}
				</ul>
			</div>
		);
	}
};

export default SelectBox;
